// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".2353b13de9892b5b2ac0dc20e9967e98f5d18685.chunk.bundle.js";
};